import { render } from "./Cbhibenefitspage.vue?vue&type=template&id=1b2feb85&scoped=true"
import script from "./Cbhibenefitspage.vue?vue&type=script&lang=js"
export * from "./Cbhibenefitspage.vue?vue&type=script&lang=js"

import "./Cbhibenefitspage.vue?vue&type=style&index=0&id=1b2feb85&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1b2feb85"]])

export default __exports__